module.exports = __webpack_public_path__ + "static/media/ic_error.c74b8ca5.svg";